// src/pages/Dashboard/components/Sidebar/CaseSidebar.js

import React from 'react';
import CaseListItem from './CaseListItem';
import './CaseSidebar.css';

/**
 * Menu lateral com lista de casos
 * @param {Array} casos - Lista de casos
 * @param {object} casoSelecionado - Caso atualmente selecionado
 * @param {boolean} isOpen - Se o menu está aberto
 * @param {boolean} loading - Se está carregando casos
 * @param {function} onSelectCaso - Callback ao selecionar caso
 * @param {function} onClose - Callback ao fechar menu
 * @param {function} onCreateNewCase - Callback para criar novo caso
 */
const CaseSidebar = ({ 
  casos, 
  casoSelecionado, 
  isOpen, 
  loading,
  onSelectCaso, 
  onClose,
  onCreateNewCase 
}) => {
  return (
    <div className={`menu-lateral ${isOpen ? 'open' : ''}`}>
      <div className="menu-lateral-header">
        <h3>Casos Salvos</h3>
        <button className="close-menu" onClick={onClose}>×</button>
      </div>
      
      <button className="btn-novo-caso-menu" onClick={onCreateNewCase}>
        + NOVO CASO
      </button>
      
      <div className="casos-lista-menu">
        {loading ? (
          <div className="loading-menu">Carregando casos...</div>
        ) : casos.length === 0 ? (
          <div className="loading-menu">Nenhum caso encontrado</div>
        ) : (
          casos.map(caso => (
            <CaseListItem
              key={caso.id}
              caso={caso}
              selected={casoSelecionado?.id === caso.id}
              onClick={() => onSelectCaso(caso)}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default CaseSidebar;